import axios, { isAxiosError } from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL as string

const apiInstance = axios.create({ baseURL: `${BASE_URL}/api` })

export const ApiService = {
  init: (serviceConfig: { getZoomContext: () => string | null; onContextInvalid: () => void }) => {
    const { getZoomContext, onContextInvalid } = serviceConfig

    const authInterceptor = (config: any) => {
      const context = getZoomContext()
      if (context) {
        config.headers['X-Zoom-App-Context'] = context
      }
      return config
    }

    const errorInterceptor = (error: any) => {
      if (isAxiosError(error)) {
        // ErrorService.captureAxiosError(error)

        if (error.response?.status === 401) {
          setTimeout(() => {
            onContextInvalid()
          })
        }
      }

      return Promise.reject(error)
    }

    apiInstance.interceptors.request.use(authInterceptor)
    apiInstance.interceptors.response.use((response) => response, errorInterceptor)
  },

  apiInstance,
}
